import React from 'react';
import styles from './styles.module.scss';

interface AudioLevelIndicatorProps {
  level: number;
  isActive: boolean;
  children: React.ReactNode;
}

export function AudioLevelIndicator({
  level,
  isActive,
  children,
}: AudioLevelIndicatorProps) {
  if (!isActive) {
    return <>{children}</>;
  }

  const smoothLevel = Math.min(level * 3, 1);

  return (
    <div className={styles.audioLevelWrapper}>
      <div
        className={styles.audioRing}
        style={{
          transform: `scale(${1 + smoothLevel * 0.4})`,
          opacity: 0.25 + smoothLevel * 0.15,
        }}
      />
      <div
        className={styles.audioRing}
        style={{
          transform: `scale(${1 + smoothLevel * 0.7})`,
          opacity: 0.15 + smoothLevel * 0.1,
        }}
      />
      <div
        className={styles.audioRing}
        style={{
          transform: `scale(${1 + smoothLevel * 1.0})`,
          opacity: 0.08 + smoothLevel * 0.07,
        }}
      />
      {children}
    </div>
  );
}
